import {
    AccountMappingAccountItem,
    AccountMappingTemplateGroupItem,
    IAccountMappingTemplateGroup,
    ItemType,
} from '@modeso/types__aumico-lib-annualreport-be';
import { TemplateType } from '@modeso/types__aumico-lib-templates-be';

export interface MappingItemsSelectionNode {
    // The raw data for this node (group, item, account, etc.)
    data: IAccountMappingTemplateGroup | AccountMappingTemplateGroupItem | AccountMappingAccountItem & { isDuplicateAccountNumber?: boolean };

    // Children if any
    children: MappingItemsSelectionNode[];

    type: ItemType;

    financialType?: TemplateType | null;

    // For UI state
    expanded?: boolean;
    selected?: boolean;

    // So we can keep track of partial matches when filtering
    visible?: boolean;
}
